// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__ZKnhF","hide":"main_hide__cKntJ"};